import { renderTextLineClamp } from 'helpers';
import { OperationsListItem } from 'modules/operation/operations/types';

export const renderTrader = (item: OperationsListItem) =>
  renderTextLineClamp(item.trader?.name);
